
const namespaced = true;

const state = {
  destPath: `/`,
  ssoToken: ``,
};

const mutations = {
  SET_DEST_PATH(state, destPath) {
    state.destPath = destPath;
  },
  SET_SSO_TOKEN(state, ssoToken) {
    state.ssoToken = ssoToken;
  },
};

const actions = {
  async login({ state, dispatch }) {
    await dispatch(`model/auth/ssoLogin`, state.ssoToken, { root: true });
    return dispatch(`model/user/fetchMe`, null, { root: true });
  },
};

const getters = {};

export default {
  namespaced, state, mutations, actions, getters,
};
